/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setSplash.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * __00: 初期設定
 **━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * 初期値
 */
const html = document.documentElement;
const splash = document.getElementById("splash");



/**
 * 処理
 */
const setSplash = () => {
  window.addEventListener("DOMContentLoaded", () => {
    if (window.name.indexOf("visited") != -1) {
      html.classList.remove("--loading");
      splash.remove();
    } else {
      setTimeout(() => { html.classList.remove("--loading"); }, 2000);
      setTimeout(() => { splash.remove() }, 3200);
    }
  });
};


/**
 * Export.
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
export {
  setSplash
};